function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "117.8%",
  x: "-.8%",
  y: "-8.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1CA6FF",
  fillRule: "evenodd",
  stroke: "#1CA6FF",
  strokeWidth: 5.355,
  d: "M100.784 83.681c.604 1.024-.13 2.319-1.317 2.319H1.533C.347 86-.388 84.705.216 83.681L49.184.753a1.527 1.527 0 0 1 2.632 0l48.968 82.928zM66.749 32.512H34.251l-15.313 26.22h63.124L66.75 32.512zM50.5 5.244L35.77 29.366h29.46L50.5 5.244zm33.594 56.634H16.906L4.208 83.902h92.584L84.094 61.878z",
  filter: "url(#a)",
  opacity: 0.127,
  transform: "translate(6 6)"
});

const SvgIcBannerCloudTiering = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 102,
    viewBox: "0 0 117 102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCloudTiering, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cloud-tiering.7e00c416.svg";
export { ForwardRef as ReactComponent };